import type { DesignDocument, DesignNode } from '@repo/api-contracts';
import type { SaveErrorInfo } from './save-error';

export interface ErrorNodeTarget {
  readonly nodeId: string;
  readonly componentId: string;
}

/** 노드가 오류 id(노드·폰트·잉크·에셋 id)를 쓰는지 — 그룹은 자식까지 본다. */
const references = (node: DesignNode, ids: ReadonlySet<string>): boolean => {
  if (ids.has(node.id)) return true;
  if (node.type === 'text') return ids.has(node.fontId) || ids.has(node.inkColorId);
  if (node.type === 'image') return ids.has(node.assetId);
  return node.children.some((child) => references(child, ids));
};

/**
 * 저장 오류가 가리키는 맨 위 레이어(문서 순서). 목록형 400 은 폰트·잉크·에셋 id 를, 'invalid' 는 노드 id 를 담는다.
 * 그룹 자식은 바깥 그룹으로 가리킨다 — 레이어 목록·선택 단위와 같다.
 */
export const errorNodeTargets = (
  document: DesignDocument,
  error: SaveErrorInfo | null,
): readonly ErrorNodeTarget[] => {
  if (error === null || error.ids.length === 0) return [];
  const ids = new Set(error.ids);
  return document.components.flatMap((component) =>
    component.layers
      .filter((node) => references(node, ids))
      .map((node) => ({ nodeId: node.id, componentId: component.componentId })),
  );
};
